import {connect} from 'formik'
import {FormGroup, HolderTitle} from './'
import {StarredField} from 'shared'

export const CompanyFields = connect(({formik}) => {
  if (!formik.values._company_donation) return null

  return <>
    <div className='donations-form-holder-label'>
      <HolderTitle />
    </div>
    <StarredField name='company_name' placeholder={I18n.t('donate.attributes.company_name')} component={FormGroup} />
  </>
})
